import AppCopy from "copy/AppCopy";

function ReportsHeader() {
  const { carNoText, reporterText, reportedText } = AppCopy.reportsPage;

  return (
    <div className={Classname.container}>
      <span className={Classname.carNo}>{carNoText}</span>
      <span className={Classname.reporter}>{reporterText}</span>
      <span className={Classname.reported}>{reportedText}</span>
    </div>
  );
}

export default ReportsHeader;

const Classname = {
  container:
    "w-full border-b hidden sm:flex items-center justify-between text-sm text-secondaryText py-2",
  carNo: "w-1/4",
  reporter: "w-1/4",
  reported: "w-1/4",
};
